module.exports = __webpack_public_path__ + "img/invited-by-user-icon.2acbf7e7.svg";